import React from 'react';
import classes from './style.module.css'
import { Button } from 'react-bootstrap';


const ToggleButton = props => {
   return (
       <div className={classes.ToggleButton}>
            <Button size="sm" className={props.active ? classes.ActiveBtn : classes.InactiveBtn} onClick={props.clicked}>{props.label0}</Button>
            <Button size="sm" className={!props.active ? classes.ActiveBtn : classes.InactiveBtn} onClick={props.clicked}>{props.label1}</Button>
       </div>
   );
}

export default ToggleButton;